module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"react","commonjs":"react","commonjs2":"react","root":"React"}
// module id = 1
// module chunks = 0